import sanitizeHtml from 'sanitize-html';

const ALLOWED_TAGS = [
  /*
   * Tags we added (that were not in the default allow list in `sanitize-html`)
   */
  'img',
  /*
   * These were already included in the default list of allowed tags in `sanitize-html`
   * List is copied here to make it an explicit white list in case the default list in
   * the library changes
   */
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
];

export function sanitizeHTML(htmlString: string): string {
  return sanitizeHtml(htmlString, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {
      '*': ['class', 'data-disclaimer-code'],
      a: ['href', 'target'],
      img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    },
  });
}
